// initial state
import * as base from './base.js'
const baseName = '/admin/api/spot'

const obj =  base.setBaseUrl('spot', baseName)
const a = Object.assign(obj,{})
export default a
